module.exports = __webpack_public_path__ + "static/media/nakamura.89c2aed8.jpg";